import listTrendingServicesRoute from "./list-trending-services-route";
import setServiceStatusRoute from "./set-service-status-route";

export default {
  "list-trending-services": listTrendingServicesRoute,
  "set-service-status": setServiceStatusRoute,
};
